import React, { useState,ReactNode } from "react";
import { ThemeProvider } from "@mui/material";
import { themeCreator } from "./base";
// import { StylesProvider } from '@mui/styles';


interface ThemeProviderWrapperProps {
  children: ReactNode;
}

export const ThemeContext = React.createContext((themeName: string): void => {});

const ThemeProviderWrapper: React.FC<ThemeProviderWrapperProps> = (props) => {
  const curThemeName = localStorage.getItem("appThemeCaaS") || "PureLightThemeCaaS";
  const [themeName, _setThemeName] = useState(curThemeName);
  const theme = themeCreator(themeName);
  const setThemeName = (themeName: string): void => {
    localStorage.setItem("appThemeCaaS", themeName);
    _setThemeName(themeName);
  };

  return (
    // <StylesProvider injectFirst>
    <ThemeContext.Provider value={setThemeName}>
      <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
    </ThemeContext.Provider>
    // </StylesProvider>
  );
};

export default ThemeProviderWrapper;
